/** Shared QR render settings for frame CTA overlays (minimal quiet zone; white backdrop is CSS). */
export const CTA_QR_CODE_RENDER_OPTIONS = {
  type: 'svg' as const,
  margin: 0,
  color: { dark: '#000000ff', light: '#ffffffff' }
}

/** Player playback and app frame/playlist previews: minimal SVG quiet zone on the white surface. */
export const CTA_QR_CODE_RENDER_OPTIONS_PLAYER = {
  ...CTA_QR_CODE_RENDER_OPTIONS,
  margin: 1
} satisfies typeof CTA_QR_CODE_RENDER_OPTIONS

/** App frame grid, playlist preview, and fullscreen — same QR quiet zone as player. */
export const CTA_QR_CODE_RENDER_OPTIONS_FRAME_PREVIEW = CTA_QR_CODE_RENDER_OPTIONS_PLAYER

/** Outer chrome: white quiet zone on busy creatives (see packages/shared/styles/cta-qr-surface.css). */
export const CTA_QR_SURFACE_CLASS = 'cta-qr-surface'

/** Catalog grid cards: no shadow (card chrome provides separation). */
export const CTA_QR_SURFACE_CLASS_FLAT = 'cta-qr-surface cta-qr-surface--flat'
